"use client";

import { useState } from "react";
import { ChevronDown } from "lucide-react";
import { ButtonBase, Menu, MenuItem, Typography } from "@mui/material";

import type { OpenRouterModel } from "@/ai/model/openrouter-models";
import { reasoningOptions } from "@/lib/ai-model-ui";

export function ThinkingSelector({
  model,
  value,
  onChange,
  disabled = false,
}: {
  model?: OpenRouterModel;
  value: string | null;
  onChange: (value: string | null) => void;
  disabled?: boolean;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  if (!model?.reasoning) return null;
  const options = reasoningOptions(model);
  return (
    <>
      <ButtonBase
        disabled={disabled}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.5,
          color: "hsl(var(--muted-foreground))",
          typography: "caption",
          borderRadius: 1,
          px: 0.75,
          py: 0.25,
          border: "1px solid hsl(var(--border))",
          "&:hover": { bgcolor: "hsl(var(--muted))" },
        }}
      >
        <Typography variant="caption" noWrap>
          Pensamento:{" "}
          {options.find((option) => option.value === value)?.label ??
            options[0]?.label}
        </Typography>
        <ChevronDown size={12} aria-hidden="true" />
      </ButtonBase>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
      >
        {options.map((option) => (
          <MenuItem
            key={option.value ?? "auto"}
            selected={option.value === value}
            onClick={() => {
              onChange(option.value);
              setAnchorEl(null);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
